import React, { useRef, useState, useEffect } from "react";
import TherapyReadyUi from "./TherapyReadyUi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CreatefilefirebaseCreateurlApi } from "../../apis/file.api";
import { callApiAction } from "../../store/actions/commonAction";
import { useDispatch, useSelector } from "react-redux";
import { titleCase } from "../../utils/main";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";
import { CreateTherapyApi } from "../../apis/therapy.api";
import { getPatientByIdApi } from "../../apis/patient.api";
import { RightDataAction, VolumeLevelsAction } from "../../store/actions/therapyAction";

function writeString(view, offset, string) {
  for (let i = 0; i < string.length; i++) {
    view.setUint8(offset + i, string.charCodeAt(i));
  }
}

function bufferToWave(abuffer) {
  const numOfChan = abuffer.numberOfChannels;
  const sampleRate = abuffer.sampleRate;
  const length = abuffer.length * numOfChan * 2 + 44;

  const buffer = new ArrayBuffer(length);
  const view = new DataView(buffer);

  // Write WAV header
  writeString(view, 0, "RIFF");
  view.setUint32(4, length - 8, true);
  writeString(view, 8, "WAVE");
  writeString(view, 12, "fmt ");
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, numOfChan, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * numOfChan * 2, true);
  view.setUint16(32, numOfChan * 2, true);
  view.setUint16(34, 16, true);
  writeString(view, 36, "data");
  view.setUint32(40, length - 44, true);

  const channels = [];
  for (let i = 0; i < numOfChan; i++) {
    channels.push(abuffer.getChannelData(i));
  }

  let offset = 44;
  for (let i = 0; i < abuffer.length; i++) {
    for (let j = 0; j < numOfChan; j++) {
      const sample = Math.max(-1, Math.min(1, channels[j][i]));
      view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7fff, true);
      offset += 2;
    }
  }

  return new Blob([buffer], { type: "audio/wav" });
}

const TherapyReadyController = () => {
  const [Patient,setPatient] = useState();
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch()
  const location = useLocation();
  const audioRef = useRef(null);
  const [objectUrl, setObjectUrl] = useState(null);
  const [audioBuffer, setAudioBuffer] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState();
  const [Soundloading, setSoundLoading] = useState(false);
// const {leftdata} = useSelector((state) => state)
  const fetchPatient = (id) => {
    // setLoading(true)
    dispatch(callApiAction(
      async () => await getPatientByIdApi({ id: params?.id }),
      (response) => {
        setPatient(response)
        setVolume(Number(response?.loudness/100))
        // setLoading(false)
      },
      (err) => {
        // setLoading(false)
      }
    ))
  }
console.log("first volume",volume)
  useEffect(() => {
    fetchPatient();
  }, []);

  useEffect(() => {
    if (location?.state?.Patient instanceof Blob) {
      const audioContext = new AudioContext();
      location.state.Patient
        .arrayBuffer()
        .then((arrayBuffer) => audioContext.decodeAudioData(arrayBuffer))
        .then((decodedBuffer) => {
          setAudioBuffer(decodedBuffer);
          const url = URL.createObjectURL(location.state.Patient);
          setObjectUrl(url);
        })
        .catch((error) => console.error("Audio Decoding Error:", error));
    }

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [location?.state?.Patient]);

  const handlePlayStopAudio = () => {
    if (!audioRef.current && objectUrl) {
      audioRef.current = new Audio(objectUrl);
      audioRef.current.volume = volume;
    }

    if (isPlaying) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    } else {
      audioRef.current
        .play()
        .then(() => setIsPlaying(true))
        .catch((err) => console.error("Audio Playback Error:", err));
    }
  };

  const handleVolumeChange = (newVolume) => {
    setVolume(newVolume / 100);
    if (audioRef.current) {
      audioRef.current.volume = newVolume / 100;
    }
  };

  const FinalSubmitButton = () => {
    if (isPlaying) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setSoundLoading(false);
    navigate(`/Patient-Details/${params.id}`);
  }

  const submit = async () => {
    if (!audioBuffer) {
      console.error("AudioBuffer is not ready!");
      return;
    }

    try {
      setSoundLoading(true)
      const frequency = Number(Patient?.frequency)

      const desiredDuration = audioBuffer.duration;
      const currentVolume = volume;

      const offlineContext = new OfflineAudioContext(
        audioBuffer.numberOfChannels,
        Math.ceil(audioBuffer.sampleRate * desiredDuration),
        audioBuffer.sampleRate
      );

      const source = offlineContext.createBufferSource();
      source.buffer = audioBuffer;

      const upperOctaveFreq = frequency * Math.pow(2, 1 / 6);
      const lowerOctaveFreq = frequency * Math.pow(2, -1 / 6);
      const octaveBandwidth = upperOctaveFreq - lowerOctaveFreq;

      const notchFilter = offlineContext.createBiquadFilter();
      notchFilter.type = "notch";
      notchFilter.frequency.value = frequency;
      notchFilter.Q.value = frequency / octaveBandwidth;

      const gainNode = offlineContext.createGain();
      gainNode.gain.value = currentVolume;

      source.connect(notchFilter);
      notchFilter.connect(gainNode);
      gainNode.connect(offlineContext.destination);

      source.start(0);
      const renderedBuffer = await offlineContext.startRendering()
      const blob = new Blob([bufferToWave(renderedBuffer)], { type: "audio/mp3" });
      const url = URL.createObjectURL(blob)
      dispatch(
        callApiAction(
          async () => await CreatefilefirebaseCreateurlApi(url),
          async (response) => {
            dispatch(
              callApiAction(
                async () => await CreateTherapyApi({ name: titleCase(location?.state?.inputdata), patient_id: params.id, audio_url: response?.url }),
                async (response) => {
                  dispatch(
                    callSnackBar(
                      "Patient Therapy is Create",
                      SNACK_BAR_VARIETNS.suceess
                    )
                  );
                  dispatch(RightDataAction([]));
                  dispatch(VolumeLevelsAction({}))
                  FinalSubmitButton();
                },
                (err) => {
                  console.log("error Create Therapy  ")
                }
              )
            )
          },
          (err) => {
            console.log("error Firebase url Of Create Therapy")
          }
        )
      )

    } catch (error) {
      console.error("Error generating or uploading WAV:", error);
    }
  };

  const BackButton = () => {
    if (isPlaying) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    // setLeft(leftdata?.leftTherapy)
    navigate(`/therapy/${params.id}`)
  }

  // useEffect(()=>{
  //   if(!isPlaying){
  //     setIsPlaying(true);
  //   }
  // },[BackButton])
  return (
    <TherapyReadyUi
      handlePlayStopAudio={handlePlayStopAudio}
      isPlaying={isPlaying}
      volume={volume * 100}
      handleVolumeChange={handleVolumeChange}
      submit={submit}
      location={location}
      Soundloading={Soundloading}
      setIsPlaying={setIsPlaying}
      BackButton={BackButton}
    />
  );
};

export default TherapyReadyController;